import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable, of } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { ICurrencyResponse } from "src/app/Models/Interface/Currency/currency-response";
import { IUpdateCurrency } from "src/app/Models/Interface/Currency/update-currency";

@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  currencyOBJ = {} as IUpdateCurrency;

  constructor(private dataService: DataService) {}

  getCurrencies(): Observable<ICurrencyResponse[]> {
    // @ts-ignore
    let currencyList: IBaseDataList<ICurrencyResponse[]> = [];
    if (localStorage.getItem("currencyList")) {
      // @ts-ignore
      currencyList = JSON.parse(localStorage.getItem("currencyList")!);
      return of(currencyList);
    }
    return this.dataService.get(APIName.currency.list);
  }

  updateCurrency(): Observable<boolean> {
    return this.dataService.post(
      APIName.currency.updateCurrency,
      this.currencyOBJ
    );
  }
}
